import { createSlice } from "@reduxjs/toolkit";
import { updateViewList } from "@reducers/_utils/reducer-helpers";

const initialState = {
  optIns: {
    android: null,
    iOS: null,
  },
  live: [],
  expired: [],
  positions: [],
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("LOAD_NOTIFICATIONS", (state, action) => {
        Object.assign(state, action.payload);
      })
      .addCase("ADD_NOTIFICATION_ITEM", (state, action) => {
        const status = action.status;
        state[status] = [action.itemDetails, ...state[status]];
      })
      .addCase("UPDATE_NOTIFICATION_ITEM", (state, action) => {
        const keyLookUp = `${action.itemType}_id`;
        const itemDetails =
          action.updateAction === "update" ? action.itemDetails : null;
        state.live = updateViewList(
          keyLookUp,
          action.itemDetails[keyLookUp],
          state.live,
          itemDetails
        );
      })
      .addCase("LOAD_NOTIFICATION_OPT_INS", (state, action) => {
        const { ios, android } = action.notificationStats;
        state.optIns = { android, iOS: ios };
      });
  },
});

export const selectNotifications = (state) => state.notifications;

export default notificationsSlice.reducer;
